const uIFormTemplateAction = {
    FORM_TEMPLATE_SETTINGS : 'form template settings',

    SAVE : 'save',

    DISCARD : 'discard',

    SAVE_AS_NEW_VERSION : 'save as new version',

    DELETE : 'delete',

    MARK_IN_PRODUCTION : 'mark in production',

    MARK_ALL_IN_PRODUCTION : 'mark all in production',

    EXPORT : 'export',

    BACKUP : 'backup',

    EXPORT_ALL : 'export all',

    SHOW_FORM_REFERENCES : 'show form references',

    RELOAD_FORM_RULES : 'reload form rules',

    RELOAD_FIELD_RULES : 'reload field rules',

    PUBLISH_FORM_TEMPLATES : 'publish form templates',

    IMPORT : 'import',

    NEW_FORM : 'new form',

    TEST_DRAFT_FORM_TEMPLATES : 'test draft form templates'

};

angular.module('gw-um-j2js')
    .constant('uIFormTemplateAction', uIFormTemplateAction);